import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Button, Modal, Text } from '@reveni-io/reveni-ui'

import { zIndexOverDrawer } from '../constants'
import ImportResultSummary from './ImportResultSummary/ImportResultSummary'
import * as Styles from './styles'

const ImportResultModal = ({ show, onClose, fileName, result, email }) => {
  const { t } = useTranslation()
  const theme = useTheme()

  if (!result) return null

  return (
    <Modal
      show={show}
      onClose={onClose}
      title={t('Revisar antes de confirmar')}
      size="l"
      zIndex={zIndexOverDrawer}
      actions={
        <Button fullWidth variant="outlined" onClick={onClose}>
          {t('Cerrar')}
        </Button>
      }
    >
      <Styles.Content>
        <Styles.FileRow>
          <Text type="bodyMBold">{t('Archivo')}:</Text>
          <Text type="bodyMRegular" color={theme.colors.text.subtle}>
            {fileName}
          </Text>
        </Styles.FileRow>
        <ImportResultSummary result={result} email={email} />
      </Styles.Content>
    </Modal>
  )
}

export default ImportResultModal
